// Growth Complex Range Carousel JavaScript
document.addEventListener('DOMContentLoaded', function() {
    // Check if Embla Carousel is available
    if (typeof EmblaCarousel === 'undefined') {
        console.warn('Embla Carousel not loaded');
        return;
    }

    // Find all sections on the page
    const sections = document.querySelectorAll('.growth-complex-section');

    sections.forEach((section) => {
        // Initialize Embla Carousel for each section
        const emblaNode = section.querySelector('.growth-complex-viewport');
        if (!emblaNode) return;

        const options = {
            loop: false,
            align: 'start',
            slidesToScroll: 1,
            containScroll: 'trimSnaps',
            dragFree: true
        };

        const emblaApi = EmblaCarousel(emblaNode, options);

        // Prevent carousel drag on special card links
        const specialCardLinks = section.querySelectorAll('.special-card-redirection-a');
        specialCardLinks.forEach(link => {
            link.addEventListener('mousedown', (e) => {
                e.stopPropagation();
            });
            link.addEventListener('touchstart', (e) => {
                e.stopPropagation();
            });
            link.addEventListener('click', (e) => {
                // Ensure the link click works
                e.stopPropagation();
            });
        });

        // Update scrollbar
        const scrollbar = section.querySelector('.growth-complex-scrollbar');
        const scrollbarThumb = section.querySelector('.growth-complex-scrollbar-thumb');

        if (!scrollbar || !scrollbarThumb) return;

        const updateScrollbar = () => {
            const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()));
            const scrollbarWidth = scrollbar.offsetWidth;
            const thumbWidth = scrollbarThumb.offsetWidth;
            const maxLeft = scrollbarWidth - thumbWidth;

            scrollbarThumb.style.left = `${progress * maxLeft}px`;
        };

        // Drag functionality
        let isDragging = false;
        let startX = 0;
        let startLeft = 0;

        // Get client X position from mouse or touch event
        const getClientX = (event) => {
            return event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
        };

        const handleDragStart = (event) => {
            event.preventDefault();
            event.stopPropagation();

            isDragging = true;
            startX = getClientX(event);
            startLeft = parseInt(scrollbarThumb.style.left) || 0;

            scrollbarThumb.classList.add('dragging');
            document.body.style.cursor = 'grabbing';
            document.body.style.userSelect = 'none';

            // Prevent scrolling on mobile when dragging
            document.body.style.touchAction = 'none';
        };

        const handleDragMove = (event) => {
            if (!isDragging) return;

            event.preventDefault();
            const deltaX = getClientX(event) - startX;
            const scrollbarWidth = scrollbar.offsetWidth;
            const thumbWidth = scrollbarThumb.offsetWidth;
            const maxLeft = scrollbarWidth - thumbWidth;

            const newLeft = Math.max(0, Math.min(maxLeft, startLeft + deltaX));
            const progress = newLeft / maxLeft;

            // Update thumb position immediately
            scrollbarThumb.style.left = `${newLeft}px`;

            // Calculate exact scroll position based on the scrollable distance
            const engine = emblaApi.internalEngine();
            const scrollSnaps = engine.scrollSnaps;
            const scrollEnd = scrollSnaps[scrollSnaps.length - 1];
            const targetPosition = progress * scrollEnd;

            // Use the internal scroll method for exact positioning
            engine.scrollBody.useFriction(0).useBaseFriction(0);
            engine.translate.to(targetPosition);
        };

        const handleDragEnd = () => {
            if (!isDragging) return;

            isDragging = false;
            scrollbarThumb.classList.remove('dragging');
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            document.body.style.touchAction = '';

            // Re-enable friction after dragging
            const engine = emblaApi.internalEngine();
            engine.scrollBody.useFriction(0.8).useBaseFriction(0.8);
        };

        // Handle scrollbar track click (not on thumb)
        const handleScrollbarClick = (event) => {
            if (event.target === scrollbarThumb) return;

            const scrollbarRect = scrollbar.getBoundingClientRect();
            const clickPosition = event.clientX - scrollbarRect.left;
            const scrollbarWidth = scrollbar.offsetWidth;
            const thumbWidth = scrollbarThumb.offsetWidth;
            const maxLeft = scrollbarWidth - thumbWidth;

            // Calculate target position (center thumb on click)
            const targetLeft = Math.max(0, Math.min(maxLeft, clickPosition - thumbWidth / 2));
            const targetProgress = targetLeft / maxLeft;

            // Scroll to target position proportionally
            const engine = emblaApi.internalEngine();
            const scrollSnaps = engine.scrollSnaps;
            const scrollEnd = scrollSnaps[scrollSnaps.length - 1];
            const targetPosition = targetProgress * scrollEnd;

            emblaApi.scrollTo(targetPosition);
        };

        // Event listeners for mouse
        scrollbarThumb.addEventListener('mousedown', handleDragStart);
        document.addEventListener('mousemove', handleDragMove);
        document.addEventListener('mouseup', handleDragEnd);

        // Event listeners for touch
        scrollbarThumb.addEventListener('touchstart', handleDragStart, { passive: false });
        document.addEventListener('touchmove', handleDragMove, { passive: false });
        document.addEventListener('touchend', handleDragEnd);
        document.addEventListener('touchcancel', handleDragEnd);

        scrollbar.addEventListener('click', handleScrollbarClick);

        emblaApi.on('scroll', updateScrollbar);
        emblaApi.on('resize', updateScrollbar);

        // Initial scrollbar position
        updateScrollbar();
    });
});
